import React from 'react';
import { TraderTemplate, TraderTemplateData } from '../../templates/TraderTemplate';

// Reliable placeholder images
const PLACEHOLDERS = {
    pfp: 'https://picsum.photos/seed/trader-pfp/400/400',
    btc: 'https://cryptologos.cc/logos/bitcoin-btc-logo.png?v=029',
    eth: 'https://cryptologos.cc/logos/ethereum-eth-logo.png?v=029',
    sol: 'https://cryptologos.cc/logos/solana-sol-logo.png?v=029',
    bnb: 'https://cryptologos.cc/logos/bnb-bnb-logo.png?v=029',
    founder: 'https://picsum.photos/seed/trader-founder/200/200',
};

// Sample data demonstrating the Trader template
const sampleTraderData: TraderTemplateData = {
    identity: {
        name: 'CryptoNova',
        handle: '@cryptonova',
        pfp: PLACEHOLDERS.pfp,
    },

    hero: {
        prelabel: 'Alpha that moved the market',
        headline: 'Turn $1K into $100K with on-chain edge',
        highlightWord: '$100K',
        subline: 'Real-time trade alerts, technical analysis, and market insights from a full-time crypto trader with 7 years of experience.',
        ctaText: 'Get Alpha Access',
        ctaLink: '#',
    },

    ticker: [
        { symbol: 'BTC', name: 'Bitcoin', price: 98450.32, change24h: 2.34, icon: PLACEHOLDERS.btc },
        { symbol: 'ETH', name: 'Ethereum', price: 3842.18, change24h: -1.23, icon: PLACEHOLDERS.eth },
        { symbol: 'SOL', name: 'Solana', price: 187.45, change24h: 5.67, icon: PLACEHOLDERS.sol },
        { symbol: 'BNB', name: 'BNB', price: 512.89, change24h: 0.89, icon: PLACEHOLDERS.bnb },
    ],

    stats: [
        { value: '847%', label: 'YTD Return' },
        { value: '73%', label: 'Win Rate' },
        { value: '12.4x', label: 'Best Trade' },
        { value: '23K+', label: 'Followers' },
    ],

    tradingViewSymbol: 'BINANCE:BTCUSDT',

    alerts: [
        {
            id: '1',
            type: 'alert',
            content: '🚀 Long $BTC at $97,800 | Target: $105K | Stop: $94K | Risk/Reward: 3.2x',
            timestamp: new Date(Date.now() - 15 * 60 * 1000), // 15 mins ago
        },
        {
            id: '2',
            type: 'news',
            content: 'Bitcoin ETF inflows surpass $1B for the 3rd consecutive day. Institutional accumulation accelerating.',
            timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000), // 2 hours ago
        },
        {
            id: '3',
            type: 'alert',
            content: '💎 Adding to $SOL position at $175. Breakout confirmed above resistance. Next target $220.',
            timestamp: new Date(Date.now() - 5 * 60 * 60 * 1000), // 5 hours ago
        },
        {
            id: '4',
            type: 'news',
            content: 'Fed signals potential rate pause in Q2. Risk assets rallying on the news.',
            timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000), // 1 day ago
        },
        {
            id: '5',
            type: 'alert',
            content: '⚠️ Closed $ETH short at $3,780 | Profit: +18% | Moving to sidelines ahead of CPI data.',
            timestamp: new Date(Date.now() - 48 * 60 * 60 * 1000), // 2 days ago
        },
    ],

    newsletter: {
        title: 'Weekly Alpha Newsletter',
        description: 'Get my top trade setups, market analysis, and alpha calls delivered every Sunday.',
        placeholder: 'your@email.com',
        buttonText: 'Subscribe Free',
    },

    founder: {
        name: 'Alex "Nova" Chen',
        handle: '@cryptonova',
        avatar: PLACEHOLDERS.founder,
        bio: 'Full-time crypto trader since 2017. Former quant at a hedge fund. Now sharing alpha with 23K+ degens. My mission: help regular people make life-changing money in crypto.',
        achievements: [
            { value: '7+', label: 'Years Trading' },
            { value: '$4.2M', label: 'Total PnL' },
            { value: '127', label: 'Winning Calls' },
        ],
    },

    social: {
        twitter: 'https://twitter.com/cryptonova',
        discord: 'https://discord.gg/cryptonova',
        telegram: 'https://t.me/cryptonova',
        youtube: 'https://youtube.com/@cryptonova',
    },
};

const TraderDemo: React.FC = () => {
    return <TraderTemplate data={sampleTraderData} />;
};

export default TraderDemo;
